import type {
  CallMenuInterface,
  CallInfoStateCallback
} from 'virtual-visit-common';
import { BaseAzureCallStrategy } from 'virtual-visit-common';
import type {
  CallStatusMessageListener,
  CallStrategy,
  CallStrategyConfig
} from './callstrategy';
import type { at } from '../generated/Beans';
import type { LanguageProperty } from 'ehs-react';
import { intl, NotificationType, notify } from 'ehs-react';
import { ViewStateStoreApi } from '../stores/viewState.store';
import type { RemoteParticipant } from '@azure/communication-calling';
type SocketDataBean = at.sense.portlets.saf.virtualvisitpatient.model.SocketDataBean;
type AzureSocketDataBeanConfig = at.sense.portlets.saf.virtualvisitpatient.model.AzureSocketDataBeanConfig;

export class AzureCallStrategy
  extends BaseAzureCallStrategy
  implements CallStrategy {
  private callStatusMessageListener: CallStatusMessageListener[] = [];

  constructor() {
    super();
  }

  getCallStrategyConfig(data: SocketDataBean): CallStrategyConfig {
    return data.azureSocketDataBeanConfig;
  }

  async initProviderAndStartCall(
    config: CallStrategyConfig,
    onReadyToClose?: () => void,
    physicianLeftMessageDelay?: number,
    participantName?: string,
    callInfoStateCallback?: CallInfoStateCallback,
    camName?: string
  ): Promise<void> {
    console.log('init provider', config);
    const azureConfig = config as AzureSocketDataBeanConfig;
    const physicianUserId = azureConfig.userIdentifier;
    const patientToken = azureConfig.token;
    const roomId = azureConfig.roomId;
    const patName = participantName || 'patient';

    await this.initAzure(
      physicianUserId,
      patientToken,
      roomId,
      patName,
      callInfoStateCallback,
      physicianLeftMessageDelay,
      camName
    );
  }

  protected updateMessage(langKey: LanguageProperty) {
    console.log('updateMessage', langKey);
    const msg = intl(langKey);
    const startingMsg = intl(
      'virtualvisitpatientportlet.view.call.starting.call'
    );
    const finalMsg = `<div>${startingMsg}</div><div>${msg}</div>`;
    this.callStatusMessageListener.forEach(lst => lst(finalMsg));
  }

  protected clearMessage() {
    this.callStatusMessageListener.forEach(lst => lst(''));
  }

  async stopCall(): Promise<void> {
    await this.azureConnector?.stopCall();
  }

  addCallStatusMessageListener(lst: CallStatusMessageListener): void {
    this.callStatusMessageListener.push(lst);
  }

  showCameraError(): void {
    notify({
      message: intl('virtualvisitoverviewportlet.switch.camera.error.msg'),
      onClose: () => {
        //nothing to do
      },
      title: intl('common.note'),
      type: NotificationType.INFO
    });
  }

  public getCallMenuInterface(): CallMenuInterface | undefined {
    return this.callMenuInterface;
  }

  protected showParticipantLeftNotification(
    participantLeftKey: string,
    participantList: readonly RemoteParticipant[]
  ): void {
    console.log(
      'showParticipantLeftNotification',
      participantLeftKey,
      participantList
    );
    if (
      participantLeftKey.startsWith('guest|') ||
      participantLeftKey.startsWith('patient')
    ) {
      return;
    }

    const urlToken = ViewStateStoreApi.getState()?.viewStateData?.guestData
      ?.urlToken;
    if (
      urlToken &&
      participantLeftKey.startsWith('patient') &&
      participantList.length > 0
    ) {
      //guest participant left
      return;
    }
    //physician participant left
  }

  setPreventPhysicianLeftNotification(prevent: boolean): void {
    this.preventParticipantLeftNotification = prevent;
  }
}
